module.exports = __webpack_public_path__ + "static/media/Aveny soffa D32R zink 3493 detalj 2023 3 fyrkant.579a36b7.jpg";